(function () {
  'use strict';

  var globalKey = 'CPDiscountAutoGift';
  var configSelector = 'script[type="application/json"][data-cp-discount-auto-gift-config]';
  var checkoutSelector = 'button[name="checkout"], input[name="checkout"], .t4s-btn__checkout, a[href*="/checkout"]';
  var discountInputSelector = 'input[name="discount"], [data-cart-discount], [data-name="discount"]';
  var saveDiscountSelector = '[data-action="save-discountcode"]';
  var cartMutationSelector = '[data-cart-remove], [data-quantity-selector], [data-action-change], [data-quantity-value]';
  var storageKey = 'cpDiscountAutoGiftCode';
  var nativeSubmit = window.HTMLFormElement && window.HTMLFormElement.prototype.submit;
  var existingState = window[globalKey];
  var cleanupTimer = null;

  if (existingState && typeof existingState.refresh === 'function') {
    existingState.refresh();
    return;
  }

  var state = {
    configs: [],
    ensureByVariant: {},
    cleanupByVariant: {},
    lastCheckoutClick: null,
    cleanup: cleanupAllGifts,
    refresh: refreshConfigs
  };

  window[globalKey] = state;

  function normalizeCode(value) {
    return String(value || '').replace(/^\s+|\s+$/g, '').toUpperCase();
  }

  function toPositiveInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return parsed > 0 ? parsed : fallback;
  }

  function getRoute(path) {
    var root = '/';

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }

    if (root.charAt(root.length - 1) !== '/') {
      root += '/';
    }

    return root + path.replace(/^\//, '');
  }

  function normalizeUrl(url, fallbackPath) {
    if (!url) return getRoute(fallbackPath);
    if (/^https?:\/\//i.test(url)) return url;
    return url.charAt(0) === '/' ? url : getRoute(url);
  }

  function parseConfig(node) {
    var config;

    try {
      config = JSON.parse(node.textContent || '{}');
    } catch (error) {
      warn('Invalid discount auto-gift config.', error);
      return null;
    }

    config.discountCode = normalizeCode(config.discountCode);
    config.variantId = String(config.variantId || '').replace(/^\s+|\s+$/g, '');
    config.quantity = toPositiveInt(config.quantity, 1);
    config.cartUrl = normalizeUrl(config.cartUrl, 'cart.js');
    config.cartAddUrl = normalizeUrl(config.cartAddUrl, 'cart/add.js');
    config.cartChangeUrl = normalizeUrl(config.cartChangeUrl, 'cart/change.js');
    config.addBeforeCheckout = config.addBeforeCheckout === true || config.addBeforeCheckout === 'true';
    if (!config.discountCode || !config.variantId) return null;

    return config;
  }

  function refreshConfigs() {
    var nodes = document.querySelectorAll(configSelector);
    var nextConfigs = [];
    var seen = {};

    for (var index = 0; index < nodes.length; index += 1) {
      var config = parseConfig(nodes[index]);
      var key;

      if (!config) continue;

      key = config.discountCode + ':' + config.variantId;
      if (seen[key]) continue;

      seen[key] = true;
      nextConfigs.push(config);
    }

    state.configs = nextConfigs;
    return nextConfigs;
  }

  function getConfigForCode(code) {
    var normalizedCode = normalizeCode(code);
    var configs = state.configs.length ? state.configs : refreshConfigs();

    if (!normalizedCode) return null;

    for (var index = 0; index < configs.length; index += 1) {
      if (configs[index].discountCode === normalizedCode) {
        return configs[index];
      }
    }

    return null;
  }

  function getCheckoutPlan(code) {
    var config = getConfigForCode(code);
    var configs;

    if (config) {
      return {
        config: config,
        hasDiscountCode: true
      };
    }

    configs = state.configs.length ? state.configs : refreshConfigs();

    for (var index = 0; index < configs.length; index += 1) {
      if (configs[index].addBeforeCheckout) {
        return {
          config: configs[index],
          hasDiscountCode: false
        };
      }
    }

    return null;
  }

  function matches(element, selector) {
    var matcher = element && (element.matches || element.msMatchesSelector || element.webkitMatchesSelector);
    return !!matcher && matcher.call(element, selector);
  }

  function closest(element, selector) {
    var node = element;

    while (node && node !== document) {
      if (matches(node, selector)) return node;
      node = node.parentElement;
    }

    return null;
  }

  function readFieldValue(scope) {
    if (!scope || !scope.querySelectorAll) return '';

    var fields = scope.querySelectorAll(discountInputSelector);

    for (var index = 0; index < fields.length; index += 1) {
      if (typeof fields[index].value !== 'undefined' && normalizeCode(fields[index].value)) {
        return fields[index].value;
      }
    }

    return '';
  }

  function readStoredCode() {
    try {
      return window.sessionStorage.getItem(storageKey) || '';
    } catch (error) {
      return '';
    }
  }

  function rememberCode(code) {
    try {
      if (code) {
        window.sessionStorage.setItem(storageKey, normalizeCode(code));
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch (error) {}
  }

  function readDiscountCode(scope) {
    return readFieldValue(scope) || readFieldValue(document) || readStoredCode();
  }

  function clearAppliedDiscount(activeField) {
    var fields = document.querySelectorAll(discountInputSelector);

    rememberCode('');

    for (var index = 0; index < fields.length; index += 1) {
      if (fields[index] === activeField || typeof fields[index].value === 'undefined') continue;
      if (getConfigForCode(fields[index].value)) {
        fields[index].value = '';
      }
    }
  }

  function ensureHiddenInput(form, name, value) {
    var input = form.querySelector('input[type="hidden"][name="' + name + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
    return input;
  }

  function syncDiscountInputs(code, form) {
    var normalizedCode = normalizeCode(code);
    var fields = document.querySelectorAll(discountInputSelector);

    for (var index = 0; index < fields.length; index += 1) {
      if (typeof fields[index].value !== 'undefined') {
        fields[index].value = normalizedCode;
      }
    }

    if (form) {
      ensureHiddenInput(form, 'discount', normalizedCode);
    }
  }

  function isCartForm(form) {
    var pathname;

    if (!form || !matches(form, 'form')) return false;
    if (form.hasAttribute('data-cart-content') || form.hasAttribute('data-cart-wrapper') || matches(form, '.t4s-drawer__wrap')) {
      return true;
    }

    try {
      pathname = new URL(form.getAttribute('action') || '', window.location.href).pathname;
      return /\/cart\/?$/i.test(pathname);
    } catch (error) {
      return (form.getAttribute('action') || '').indexOf('/cart') !== -1;
    }
  }

  function isCheckoutUrl(url) {
    var value = String(url || '');
    var pathname;

    if (!value) return false;

    try {
      pathname = new URL(value, window.location.href).pathname;
      return /\/checkout\/?$/i.test(pathname) || /\/checkouts\//i.test(pathname);
    } catch (error) {
      return /\/checkout(?:[/?#]|$)/i.test(value) || /\/checkouts\//i.test(value);
    }
  }

  function isCheckoutControl(control) {
    if (!control) return false;
    if (normalizeCode(control.getAttribute('name')) === 'CHECKOUT' || matches(control, '.t4s-btn__checkout')) return true;
    return matches(control, 'a[href]') && isCheckoutUrl(control.getAttribute('href'));
  }

  function getCheckoutHref(href, config, includeDiscount) {
    var target = href || getRoute('checkout');
    var separator;

    if (!includeDiscount) return target;

    try {
      var url = new URL(target, window.location.href);
      url.searchParams.set('discount', config.discountCode);
      return url.href;
    } catch (error) {
      separator = target.indexOf('?') === -1 ? '?' : '&';
      return target + separator + 'discount=' + encodeURIComponent(config.discountCode);
    }
  }

  function getSubmitter(event, form) {
    if (event.submitter) return event.submitter;

    if (
      state.lastCheckoutClick &&
      state.lastCheckoutClick.form === form &&
      Date.now() - state.lastCheckoutClick.time < 2000
    ) {
      return state.lastCheckoutClick.control;
    }

    return null;
  }

  function fetchJson(url, options) {
    var requestOptions = options || {};
    var headers = requestOptions.headers || {};

    headers.Accept = headers.Accept || 'application/json';
    requestOptions.headers = headers;
    requestOptions.credentials = 'same-origin';

    return window.fetch(url, requestOptions).then(function (response) {
      return response.text().then(function (text) {
        var data = {};

        if (text) {
          try {
            data = JSON.parse(text);
          } catch (error) {
            data = {};
          }
        }

        if (!response.ok || data.status >= 400) {
          throw data;
        }

        return data;
      });
    });
  }

  function cartHasVariant(cart, variantId) {
    var items = cart && cart.items ? cart.items : [];

    for (var index = 0; index < items.length; index += 1) {
      if (String(items[index].variant_id || items[index].id) === String(variantId)) {
        return true;
      }
    }

    return false;
  }

  function getVariantLineItem(cart, variantId) {
    var items = cart && cart.items ? cart.items : [];

    for (var index = 0; index < items.length; index += 1) {
      if (String(items[index].variant_id || items[index].id) === String(variantId) && Number(items[index].quantity || 0) > 0) {
        return items[index];
      }
    }

    return null;
  }

  function cartHasNonGiftItem(cart, variantId) {
    var items = cart && cart.items ? cart.items : [];

    for (var index = 0; index < items.length; index += 1) {
      if (String(items[index].variant_id || items[index].id) !== String(variantId) && Number(items[index].quantity || 0) > 0) {
        return true;
      }
    }

    return false;
  }

  function dispatch(target, eventName, detail) {
    var event;

    try {
      event = new window.CustomEvent(eventName, {
        bubbles: true,
        cancelable: true,
        detail: detail || {}
      });
    } catch (error) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, true, true, detail || {});
    }

    target.dispatchEvent(event);
  }

  function notifyCartChanged(detail) {
    dispatch(document, 'cart:item-added', detail);
    dispatch(document, 'cart:refresh', detail);
    dispatch(window, 'cart:updated', detail);
  }

  function addGift(config) {
    return fetchJson(config.cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(config.variantId),
            quantity: config.quantity
          }
        ]
      })
    });
  }

  function removeGift(config, lineItem) {
    return fetchJson(config.cartChangeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineItem.key || Number(config.variantId),
        quantity: 0
      })
    });
  }

  function ensureGift(config) {
    var variantKey = String(config.variantId);
    var promise = state.ensureByVariant[variantKey];

    if (promise) return promise;

    promise = fetchJson(config.cartUrl)
      .then(function (cart) {
        if (cartHasVariant(cart, config.variantId)) return cart;
        if (!cartHasNonGiftItem(cart, config.variantId)) return cart;
        return addGift(config).then(function (result) {
          notifyCartChanged({
            source: 'cp-discount-auto-gift',
            discountCode: config.discountCode,
            variantId: config.variantId,
            result: result
          });
          return result;
        });
      });

    state.ensureByVariant[variantKey] = promise.then(
      function (result) {
        delete state.ensureByVariant[variantKey];
        return result;
      },
      function (error) {
        delete state.ensureByVariant[variantKey];
        throw error;
      }
    );

    return state.ensureByVariant[variantKey];
  }

  function removeGiftIfOrphaned(config) {
    var variantKey = String(config.variantId);
    var promise = state.cleanupByVariant[variantKey];

    if (promise) return promise;

    promise = fetchJson(config.cartUrl)
      .then(function (cart) {
        var giftLineItem = getVariantLineItem(cart, config.variantId);

        if (cartHasNonGiftItem(cart, config.variantId)) return cart;

        clearAppliedDiscount(null);

        if (!giftLineItem) return cart;

        return removeGift(config, giftLineItem).then(function (result) {
          notifyCartChanged({
            source: 'cp-discount-auto-gift',
            action: 'remove-orphaned-gift',
            discountCode: config.discountCode,
            variantId: config.variantId,
            result: result
          });

          return result;
        });
      });

    state.cleanupByVariant[variantKey] = promise.then(
      function (result) {
        delete state.cleanupByVariant[variantKey];
        return result;
      },
      function (error) {
        delete state.cleanupByVariant[variantKey];
        throw error;
      }
    );

    return state.cleanupByVariant[variantKey];
  }

  function cleanupAllGifts() {
    var configs = state.configs.length ? state.configs : refreshConfigs();
    var promises = [];

    for (var index = 0; index < configs.length; index += 1) {
      promises.push(
        removeGiftIfOrphaned(configs[index]).catch(function (error) {
          warn('Unable to remove the discount auto-gift after the qualifying product was removed.', error);
        })
      );
    }

    return Promise.all(promises);
  }

  function scheduleGiftCleanup(delay) {
    if (cleanupTimer) {
      window.clearTimeout(cleanupTimer);
    }

    cleanupTimer = window.setTimeout(function () {
      cleanupTimer = null;
      cleanupAllGifts();
    }, delay || 350);
  }

  function handleCartChanged() {
    scheduleGiftCleanup(350);
  }

  function handleCartMutationIntent(event) {
    if (closest(event.target, cartMutationSelector)) {
      scheduleGiftCleanup(900);
    }
  }

  function setBusy(form, submitter) {
    if (form) {
      form.setAttribute('data-cp-discount-auto-gift-busy', 'true');
    }

    if (submitter) {
      submitter.setAttribute('aria-busy', 'true');
      submitter.setAttribute('aria-disabled', 'true');
      submitter.classList.add('is--loading');
      if ('disabled' in submitter) {
        submitter.disabled = true;
      }
    }
  }

  function submitCartForm(form) {
    ensureHiddenInput(form, 'checkout', '');

    if (nativeSubmit) {
      nativeSubmit.call(form);
    } else {
      form.submit();
    }
  }

  function handleCheckoutSubmit(event) {
    var form = event.target;
    var submitter;
    var plan;

    if (!isCartForm(form)) return;

    submitter = getSubmitter(event, form);
    if (!isCheckoutControl(submitter)) return;

    plan = getCheckoutPlan(readDiscountCode(form));
    if (!plan) return;

    event.preventDefault();

    if (plan.hasDiscountCode) {
      syncDiscountInputs(plan.config.discountCode, form);
      rememberCode(plan.config.discountCode);
    }

    setBusy(form, submitter);

    ensureGift(plan.config).catch(function (error) {
      warn('Unable to add the discount auto-gift before checkout.', error);
    }).then(function () {
      submitCartForm(form);
    });
  }

  function handleCheckoutClick(event) {
    var control = closest(event.target, checkoutSelector);
    var form;
    var plan;
    var href;

    if (!isCheckoutControl(control)) return;

    form = control.form || closest(control, 'form');

    state.lastCheckoutClick = {
      control: control,
      form: form,
      time: Date.now()
    };

    if (!matches(control, 'a[href]') || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    href = control.getAttribute('href');
    if (!isCheckoutUrl(href)) return;

    plan = getCheckoutPlan(readDiscountCode(form || document));
    if (!plan) return;

    event.preventDefault();

    if (plan.hasDiscountCode) {
      syncDiscountInputs(plan.config.discountCode, form);
      rememberCode(plan.config.discountCode);
    }

    setBusy(form, control);

    ensureGift(plan.config).catch(function (error) {
      warn('Unable to add the discount auto-gift before checkout link navigation.', error);
    }).then(function () {
      window.location.href = getCheckoutHref(href, plan.config, plan.hasDiscountCode);
    });
  }

  function warn(message, error) {
    if (window.console && typeof window.console.warn === 'function') {
      window.console.warn(message, error || '');
    }
  }

  function handleSaveDiscount(event) {
    var button = closest(event.target, saveDiscountSelector);
    var scope;
    var code;
    var config;

    if (!button) return;

    scope = closest(button, '.t4s-mini_cart-tool__content') || closest(button, 'form') || document;
    code = readFieldValue(scope);
    config = getConfigForCode(code);

    if (!config) {
      clearAppliedDiscount(scope.querySelector(discountInputSelector));
      return;
    }

    syncDiscountInputs(config.discountCode, closest(button, 'form'));
    rememberCode(config.discountCode);

    ensureGift(config).catch(function (error) {
      warn('Unable to add the discount auto-gift after saving the discount code.', error);
    });
  }

  function handleDiscountInput(event) {
    var target = event.target;
    var code;
    var config;

    if (!matches(target, discountInputSelector)) return;

    code = normalizeCode(target.value);
    config = getConfigForCode(code);

    if (!code || !config || normalizeCode(readStoredCode()) !== config.discountCode) {
      clearAppliedDiscount(target);
    }
  }

  refreshConfigs();

  document.addEventListener('click', handleCheckoutClick, true);
  document.addEventListener('click', handleSaveDiscount, false);
  document.addEventListener('click', handleCartMutationIntent, false);
  document.addEventListener('input', handleDiscountInput, false);
  document.addEventListener('change', handleDiscountInput, false);
  document.addEventListener('change', handleCartMutationIntent, false);
  document.addEventListener('submit', handleCheckoutSubmit, true);
  document.addEventListener('cart:refresh', handleCartChanged, false);
  window.addEventListener('cart:updated', handleCartChanged, false);
})();
